import { useHistory, useLocation } from 'react-router-dom'
import placeholder from '../../assets/images/img-placeholder.jpg'
import { Card } from '@mui/material'
import { FaArrowLeft } from 'react-icons/fa'
import LogoNevula from '../../assets/images/logo-only-blue.svg'
import Form from '../../components/Form'
import { useForm } from 'react-hook-form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import Button from '../../components/General/Button'
import { useState } from 'react'
import Select from '../../components/Inputs/Select'
import axios from 'axios'
import useSnackBars from '../../hooks/SnackbarConsumerHook'

const server = process.env.REACT_APP_SERVER_URL

export const CreateClientView = () => {
  const { addAlert } = useSnackBars()

  const [loading, setLoading] = useState<boolean>(false)

  const location = useLocation()
  const data = location.state as any

  const history = useHistory()

  const form = useForm()

  const docs = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
    {
      value: 'E',
      text: 'E',
    },
    {
      value: 'P',
      text: 'P',
    },
    {
      value: 'G',
      text: 'G',
    },
    {
      value: 'C',
      text: 'C',
    },
  ]

  const [typeDocumentSelected, setTypeDocumentSelected] = useState<{
    value: number | string
    text: string
  }>({
    value: 'V',
    text: 'V',
  })

  const onSubmitForm = async (values: any) => {
    try {
      setLoading(true)
      await axios.post(`${server}/thirdparty/client`, values)
      addAlert({
        message: 'Cliente creado con éxito',
        status: 'success',
      })

      history.push('/inventory')
    } catch (err) {
      addAlert({
        message: 'Error al crear cliente',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="flex flex-row justify-between items-center">
        <FaArrowLeft
          style={{ color: '#2961D0' }}
          onClick={() => history?.push('/sales')}
        />

        <img src={LogoNevula} alt="zerux" style={{ height: 35, width: 35 }} />
      </div>

      <Form form={form} onSubmit={onSubmitForm} classes="gap-x-2 p-2">
        <FormItem
          name="document.documentType"
          defaultValue={docs[0]}
          rules={{ required: 'Es necesario el campo' }}
          classes="xl:col-start-3 col-start-1 xl:col-span-2 col-span-3"
        >
          <Select
            options={docs}
            setSelectedHelper={async (v) => {
              setTypeDocumentSelected(v)
              // let value = await onCheckCb(
              //   useType,
              //   form.getValues().document,
              //   v.value,
              //   userConfig.rowsPerPage,
              //   '/thirdparty/client?',
              //   'clients'
              // )
            }}
            label="Tipo"
          />
        </FormItem>

        <FormItem
          name="document.document"
          classes="xl:col-span-8 col-span-9"
          rules={{
            required: 'Es necesario el documento',
            pattern: { value: /^\d+$/, message: 'Documento inválido' },
            minLength: {
              value: 6,
              message: 'El documento debe de poseer al menos 6 caracteres.',
            },
          }}
        >
          <InputText
            isUpperValue={false}
            label="Documento"
            maxLength={10}
            onCheckIfExist={async () => {
              console.log('in...')
              // let value = await onCheckCb(
              //   useType,
              //   form.getValues().document,
              //   form.getValues().documentType,
              //   userConfig.rowsPerPage,
              //   '/thirdparty/client?',
              //   'clients'
              // )
            }}
          />
        </FormItem>

        <FormItem name="name" classes="col-span-12">
          <InputText small label="Nombre" maxLength={80} isUpperValue={false} />
        </FormItem>

        <FormItem name="email" classes="col-span-12">
          <InputText
            small
            label="Correo electrónico"
            maxLength={80}
            isUpperValue={false}
          />
        </FormItem>

        <FormItem name="address.country" classes="col-span-12">
          <InputText small label="País" maxLength={80} isUpperValue={false} />
        </FormItem>

        <FormItem name="address.state" classes="col-span-12">
          <InputText small label="Estado" maxLength={80} isUpperValue={false} />
        </FormItem>

        <FormItem name="address.city" classes="col-span-12">
          <InputText small label="Ciudad" maxLength={80} isUpperValue={false} />
        </FormItem>

        <FormItem name="address.postalCode" classes="col-span-12">
          <InputText
            small
            label="Código postal"
            maxLength={80}
            isUpperValue={false}
          />
        </FormItem>

        <FormItem name="address.address" classes="col-span-12">
          <InputText
            small
            label="Dirección exacta del RIF"
            maxLength={80}
            isUpperValue={false}
          />
        </FormItem>

        <FormItem name="phone_1" classes="col-span-12">
          <InputText
            small
            label="Número de teléfono"
            maxLength={80}
            isUpperValue={false}
          />
        </FormItem>

        <div className="col-span-12 flex justify-center">
          <Button
            loading={loading}
            type="primary"
            classes="w-1/2 mt-5"
            htmlType="submit"
          >
            Crear cliente
          </Button>
        </div>
      </Form>
    </>
  )
}
